const medicineBazarDe = {
	search: {
		placeholders: [
			'Medikamentennamen eingeben...',
			'Generischen Namen eingeben...',
			'Firmennamen eingeben...',
			'Markenname eingeben...',
			'Shop-/Apothekenname eingeben...'
		]
	},
	sidebar: {
		categoriesTitle: 'Kategorien',
		storesTitle: 'Apotheken'
	},
	upload: {
		title: 'Rezept hochladen',
		subtitle: 'Laden Sie das Rezept Ihres Arztes hoch und bestellen Sie Medikamente bequem',
		uploadedPrefix: '✓ Datei hochgeladen:',
		chooseFile: 'Datei auswählen',
		replaceFile: 'Neue Datei hochladen'
	},
	store: {
		serviceAreaLabel: 'Liefergebiet',
		nationwide: 'Landesweit',
		medicineCountLabel: 'Medikamente',
		close: 'Schließen',
		productsOfSuffix: 'Medikamente',
		descriptionPrefix: 'Unten finden Sie alle verfügbaren Medikamente von',
		descriptionSuffix: 'Apotheke. Sie können nach Kategorie filtern.'
	},
	card: {
		addToCart: 'In die Tasche'
	},
	empty: {
		title: 'Keine Medikamente gefunden',
		subtitle: 'Bitte wählen Sie eine andere Kategorie oder Apotheke'
	},
	prescriptionFlow: {
		successTitle: 'Rezept erfolgreich hochgeladen!',
		instruction: 'Bitte füllen Sie die folgenden Angaben aus, um Ihre Bestellung aufzugeben',
		step1: {
			title: 'Apotheke wählen',
			subtitle: 'Bei welcher Apotheke möchten Sie kaufen?',
			next: 'Weiter'
		},
		step2: {
			title: 'Therapiedauer wählen',
			subtitle: 'Für wie viele Tage benötigen Sie Medikamente?',
			fullCourse: 'Voller Kurs',
			fiveDays: 'Für 5 Tage',
			tenDays: 'Für 10 Tage',
			customDays: 'Eigene Angabe',
			customDaysLabel: 'Wie viele Tage?',
			customDaysPlaceholder: 'z. B. 15',
			back: 'Zurück',
			next: 'Weiter'
		},
		step3: {
			title: 'Bestellung bestätigen',
			summaryTitle: 'Ihre Bestellübersicht:',
			pharmacyLabel: 'Apotheke',
			durationLabel: 'Therapiedauer',
			prescriptionLabel: 'Rezept',
			back: 'Zurück',
			confirm: 'Bestellung bestätigen'
		},
		snackbar: {
			successTitle: '🎉 Bestellung erfolgreich eingereicht!',
			message: 'Ihre gewählte Apotheke wird sich bald mit Preis und Details melden.'
		}
	}
};

export default medicineBazarDe;


